import React, { FC } from "react";

import { useAuth } from "keycloak/context/AuthContext";

import AuthRoutes from "./Auth";
import NonAuthRoutes from "./NonAuth";
import ErrorBoundary from "../ErrorBoundary";

const Routes: FC = () => {
  const { loading, isAuthenticated } = useAuth();

  if (loading) {
    return <>Loading...</>;
  }

  const UserRoutes = isAuthenticated ? AuthRoutes : NonAuthRoutes;

  return (
    <ErrorBoundary>
      <UserRoutes />
    </ErrorBoundary>
  );
};

export default Routes;
